import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "administrative-fee" }
const _hoisted_2 = {
  key: 2,
  class: "display-file"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "verificationStatus" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_alert icon" }, null, -1)
const _hoisted_6 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", null, [
        (!_ctx.file)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: _ctx.$t(`forms.administrative_fee.button_text`),
              class: "defaultButton whiteBG",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.triggerUploadFunction()))
            }, null, 8, ["label"]))
          : _createCommentVNode("", true),
        (!_ctx.file)
          ? (_openBlock(), _createElementBlock("input", {
              key: 1,
              ref: "fileUpload",
              id: "fileUpload",
              type: "file",
              style: {"display":"none"},
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.uploadFile()))
            }, null, 544))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                src: _ctx.file,
                alt: _ctx.$t('accessibility.administrative_fee.image')
              }, null, 8, _hoisted_3),
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.selectedFileData.name), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.presentFileSize(_ctx.selectedFileData.size)), 1)
              ]),
              _createElementVNode("i", {
                class: "icon-warpit_icon_trash",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.file = null))
              })
            ]))
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showErrorDialog,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showErrorDialog) = $event)),
      class: "successDialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("forms.errors.invalid_file")), 1)
        ]),
        _createElementVNode("button", {
          class: "defaultButton",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showErrorDialog = false))
        }, _toDisplayString(_ctx.$t("dialog.close")), 1)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}